import { render, staticRenderFns } from "./JerseySize.vue?vue&type=template&id=772c0d2c&scoped=true&"
import script from "./JerseySize.vue?vue&type=script&lang=js&"
export * from "./JerseySize.vue?vue&type=script&lang=js&"
import style0 from "./JerseySize.vue?vue&type=style&index=0&id=772c0d2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772c0d2c",
  null
  
)

export default component.exports